import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardOverview from "./DashboardOverview";
import Balances from "./Balances";
import Deposit from "./Deposit";
import Withdraw from "./Withdraw";
import Transactions from "./Transactions";
import KYCVerification from "./KYCVerification";
import Profile from "./Profile";

const Dashboard = () => {
  return (
    <Routes>
      <Route index element={<DashboardOverview />} />
      <Route path="balances" element={<Balances />} />
      <Route path="deposit" element={<Deposit />} />
      <Route path="withdraw" element={<Withdraw />} />
      <Route path="transactions" element={<Transactions />} />
      <Route path="kyc" element={<KYCVerification />} />
      <Route path="profile" element={<Profile />} />
    </Routes>
  );
};

export default Dashboard;
